var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370.789,
    height: 306,
    viewBox: "0 0 370.789 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1431",
    "data-name": "Group 1431",
    transform: "translate(-223.688 -204)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1307",
    "data-name": "Group 1307",
    transform: "translate(0 18.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_6",
    "data-name": "Union 6",
    d: "M2.681,9.8l-.018,0L0,0,6.181.895A4.482,4.482,0,0,1,8.253.38a4.758,4.758,0,0,1,3.169,1.274l2.561.371V8.106h0c-.035,4.178-2.587,7.552-5.73,7.552C5.548,15.658,3.281,13.158,2.681,9.8Z",
    transform: "translate(349.962 278.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(280.948 185.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1287",
    "data-name": "Group 1287",
    transform: "translate(224.188 212.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M64.066,0A64.066,64.066,0,1,1,0,64.066,64.066,64.066,0,0,1,64.066,0Z",
    fill: "none",
    stroke: "#fd9926",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 59.395,
    cy: 59.395,
    r: 59.395,
    transform: "translate(4.672 4.672)",
    fill: "none",
    stroke: "#fd9926",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M3.337,0A3.337,3.337,0,1,1,0,3.337,3.337,3.337,0,0,1,3.337,0Z",
    transform: "translate(60.73 60.73)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M308.574,188.25H338.6v-36.7",
    transform: "translate(-274.538 -124.183)",
    fill: "none",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M532.928,188.8a1.523,1.523,0,1,0-1.523,1.524A1.524,1.524,0,0,0,532.928,188.8Z",
    transform: "translate(-95.646 80.766)",
    fill: "#fff",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1288",
    "data-name": "Group 1288",
    transform: "translate(315.229 266.728)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 19.064,
    height: 76.913,
    transform: "translate(110.768 126.874)",
    fill: "#333f50"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 240.601,
    height: 145.938,
    fill: "#333f50",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1243",
    "data-name": "Group 1243",
    transform: "translate(8.67 5.259)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 223.26,
    height: 135.42,
    fill: "#fff",
    stroke: "#f6f7f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 223.26,
    height: 8.155,
    transform: "translate(0 127.265)",
    fill: "#fff",
    stroke: "#f6f7f7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1291",
    "data-name": "Group 1291",
    transform: "translate(507.09 238.525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1253",
    "data-name": "Group 1253"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 48.74,
    height: 32.346,
    transform: "translate(0 28.204)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M0,0H64.728V50.9H0Z",
    transform: "translate(3.255 7.482)",
    fill: "#fff",
    stroke: "#fd9926",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_196",
    "data-name": "Rectangle 196",
    width: 5.298,
    height: 13.858,
    transform: "translate(12.437)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 5.298,
    height: 13.858,
    transform: "translate(33.481)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 5.298,
    height: 13.858,
    transform: "translate(54.524)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1254",
    "data-name": "Group 1254",
    transform: "translate(8.294 25.443)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_199",
    "data-name": "Rectangle 199",
    width: 6.474,
    height: 6.474,
    fill: "#eef0f2",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_200",
    "data-name": "Rectangle 200",
    width: 6.474,
    height: 6.474,
    transform: "translate(9.852)",
    fill: "#eef0f2",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_201",
    "data-name": "Rectangle 201",
    width: 6.474,
    height: 6.474,
    transform: "translate(19.704)",
    fill: "#eef0f2",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    "data-name": "Rectangle 202",
    width: 6.474,
    height: 6.474,
    transform: "translate(29.556)",
    fill: "#eef0f2",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_203",
    "data-name": "Rectangle 203",
    width: 6.474,
    height: 6.474,
    transform: "translate(39.408)",
    fill: "#eef0f2",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M0,0H6.474V6.474H0Z",
    transform: "translate(49.26)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1255",
    "data-name": "Group 1255",
    transform: "translate(8.294 34.984)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_205",
    "data-name": "Rectangle 205",
    width: 6.474,
    height: 6.474,
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_206",
    "data-name": "Rectangle 206",
    width: 6.474,
    height: 6.474,
    transform: "translate(9.852)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_207",
    "data-name": "Rectangle 207",
    width: 6.474,
    height: 6.474,
    transform: "translate(19.704)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_208",
    "data-name": "Rectangle 208",
    width: 6.474,
    height: 6.474,
    transform: "translate(29.556)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_209",
    "data-name": "Rectangle 209",
    width: 6.474,
    height: 6.474,
    transform: "translate(39.408)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_210",
    "data-name": "Rectangle 210",
    width: 6.474,
    height: 6.474,
    transform: "translate(49.26)",
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1256",
    "data-name": "Group 1256",
    transform: "translate(8.294 44.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_211",
    "data-name": "Rectangle 211",
    width: 6.474,
    height: 6.474,
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_212",
    "data-name": "Rectangle 212",
    width: 6.474,
    height: 6.474,
    transform: "translate(9.852)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_213",
    "data-name": "Rectangle 213",
    width: 6.474,
    height: 6.474,
    transform: "translate(19.704)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_214",
    "data-name": "Rectangle 214",
    width: 6.474,
    height: 6.474,
    transform: "translate(29.556)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_215",
    "data-name": "Rectangle 215",
    width: 6.474,
    height: 6.474,
    transform: "translate(39.408)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 6.474,
    height: 6.474,
    transform: "translate(49.26)",
    fill: "#eef0f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1292",
    "data-name": "Group 1292",
    transform: "translate(332.756 254.252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M448.218,169.936H405.174a2.887,2.887,0,0,0-2.887,2.887v27.313a2.888,2.888,0,0,0,2.887,2.888h3.015l6.618,8.823.827-8.823h32.584a2.888,2.888,0,0,0,2.887-2.888V172.823A2.887,2.887,0,0,0,448.218,169.936Z",
    transform: "translate(-402.287 -169.936)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 33.354,
    transform: "translate(8.14 8.894)",
    fill: "#0169ee",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    x2: 33.354,
    transform: "translate(8.14 15.969)",
    fill: "#0169ee",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_48",
    "data-name": "Line 48",
    x2: 33.354,
    transform: "translate(8.14 23.044)",
    fill: "#0169ee",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M514.042,434.459l-70.682,4.568v4.6H582.642v-4.6Z",
    transform: "translate(-77.937 30.175)",
    fill: "#333f50"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1289",
    "data-name": "Group 1289",
    transform: "translate(258.024 350.221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1249",
    "data-name": "Group 1249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M257.627,319.17c2.191.957,7.549.836,7.554.836.055,0-1.152-3.508-1.253-3.721-1.176-2.459-4.894-6.521-7.92-6.112a3.614,3.614,0,0,0-2.9,4.528C253.611,316.8,255.761,318.354,257.627,319.17Z",
    transform: "translate(-252.999 -294.602)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M259.592,330.693c2.273.331,7.055-1.055,7.436-1.168a64.136,64.136,0,0,0,2.9,8.026c.658,1.523,1.368,3.037,2.1,4.545-.436-.639-.831-1.207-.895-1.281-1.784-2.061-6.443-5-9.252-3.8a3.611,3.611,0,0,0-1.6,5.132c1.037,1.889,3.523,2.823,5.538,3.116,2.045.3,6.145-.8,7.227-1.108.286.576.566,1.154.855,1.728,1.385,2.757,2.779,5.5,4.063,8.239.453.963.864,1.929,1.279,2.894-.388-.568-.72-1.042-.778-1.109-1.784-2.061-6.442-5-9.252-3.8a3.612,3.612,0,0,0-1.6,5.132c1.039,1.889,3.523,2.823,5.539,3.117,1.951.284,5.745-.7,7.032-1.055.395,1,.792,2,1.129,2.99.215.679.47,1.319.647,2.013l.566,2.032c.313,1.3.644,2.648.918,3.928.2.889.367,1.739.542,2.6-.44-.965-1.341-2.835-1.434-2.982-1.45-2.308-5.61-5.915-8.569-5.162a3.613,3.613,0,0,0-2.36,4.832c.74,2.024,3.055,3.324,5,3.919,2.144.655,6.891.056,7.483-.022.285,1.418.548,2.8.775,4.109.508,2.887.892,5.475,1.184,7.665h2c-.349-2.266-.8-4.966-1.409-8-.283-1.441-.614-2.975-.97-4.548a39.235,39.235,0,0,0,4.175-1.963c1.563,1.692,5.566,3.672,6.085,3.924-.545,1.34-1.088,2.638-1.62,3.855-1.107,2.548-2.159,4.808-3.087,6.73h2.164c.8-1.772,1.676-3.79,2.59-6.026.559-1.358,1.13-2.821,1.7-4.328.574.12,5.273,1.075,7.463.58,1.985-.449,4.391-1.572,5.281-3.536a3.613,3.613,0,0,0-1.995-4.993c-2.893-.973-7.311,2.314-8.93,4.508-.1.13-.974,1.65-1.513,2.617.231-.617.46-1.214.69-1.852.463-1.258.886-2.528,1.346-3.893q.3-1,.605-2.021c.216-.67.359-1.406.544-2.115.394-1.653.712-3.346.994-5.059,1.1.4,5.042,1.772,7.083,1.628s4.579-.889,5.755-2.7a3.614,3.614,0,0,0-1.214-5.238c-2.714-1.4-7.579,1.181-9.51,3.1-.121.119-1.352,1.655-2.012,2.512.162-1.031.328-2.059.459-3.108.375-3.027.662-6.1.961-9.17.091-.939.193-1.875.292-2.811.391.147,5.038,1.877,7.323,1.716,2.03-.142,4.579-.889,5.755-2.7a3.612,3.612,0,0,0-1.214-5.237c-2.713-1.4-7.578,1.18-9.51,3.1-.146.145-1.914,2.357-2.337,2.942.218-2.062.454-4.116.77-6.13a63.52,63.52,0,0,1,1.759-8.062c.182.069,5.023,1.9,7.364,1.732,2.031-.143,4.579-.889,5.756-2.7a3.613,3.613,0,0,0-1.214-5.238c-2.714-1.4-7.577,1.18-9.511,3.1-.15.151-2.053,2.532-2.367,2.989.045-.153.076-.317.122-.469a46.54,46.54,0,0,1,3.193-7.63c.7-1.358,1.435-2.618,2.182-3.828.867.433,4.851,2.367,6.973,2.452,2.034.081,4.649-.38,6.016-2.046a3.613,3.613,0,0,0-.631-5.34c-2.544-1.688-7.662.341-9.794,2.04-.116.093-1.191,1.163-1.962,1.953.346-.541.692-1.1,1.033-1.616,1.277-1.923,2.565-3.606,3.718-5.087.663-.837,1.277-1.58,1.861-2.27,1.072-.019,5.392-.15,7.28-1.036,1.843-.866,3.951-2.481,4.4-4.589a3.613,3.613,0,0,0-3.021-4.448c-3.036-.327-6.643,3.833-7.752,6.324-.1.216-1.207,3.754-1.152,3.753h.064c-.574.652-1.183,1.358-1.832,2.143-1.188,1.459-2.516,3.118-3.839,5.02a64.143,64.143,0,0,0-3.981,6.343,47.071,47.071,0,0,0-3.4,7.655c-.011.031-.017.066-.028.1.016-.895-.024-3.4-.048-3.588-.351-2.7-2.616-7.722-5.619-8.278a3.614,3.614,0,0,0-4.167,3.4c-.176,2.148,1.382,4.3,2.9,5.655,1.712,1.53,6.466,3.011,6.845,3.128a64.116,64.116,0,0,0-2.008,8.294c-.291,1.634-.534,3.288-.756,4.949-.012-.774-.027-1.466-.041-1.562-.35-2.7-2.616-7.721-5.619-8.277a3.612,3.612,0,0,0-4.166,3.4c-.177,2.148,1.381,4.3,2.9,5.654,1.541,1.377,5.568,2.722,6.639,3.063-.079.638-.164,1.275-.24,1.914-.366,3.064-.718,6.123-1.156,9.113-.153,1.054-.343,2.086-.53,3.118-.011-.686-.025-1.265-.037-1.353-.35-2.7-2.616-7.722-5.617-8.277a3.614,3.614,0,0,0-4.168,3.4c-.176,2.147,1.382,4.3,2.9,5.654,1.471,1.314,5.178,2.589,6.448,3-.223,1.053-.445,2.107-.708,3.117-.2.686-.336,1.359-.57,2.037q-.327,1.013-.647,2.007c-.459,1.261-.924,2.564-1.4,3.783-.326.85-.653,1.654-.979,2.465.165-1.047.445-3.1.449-3.278a14.034,14.034,0,0,0-1.882-6.826,4.268,4.268,0,0,0-.049-.8,3.614,3.614,0,0,0-4.418-3.065c-2.951.786-4.822,5.964-4.961,8.687-.008.161.1,1.914.181,3.018-.149-.642-.286-1.267-.446-1.925-.309-1.305-.657-2.6-1.024-3.991q-.3-1-.612-2.019c-.189-.678-.476-1.37-.713-2.064-.584-1.595-1.253-3.184-1.961-4.769,1.142-.274,5.183-1.3,6.806-2.549s3.328-3.268,3.313-5.423a3.613,3.613,0,0,0-3.9-3.7c-3.035.329-5.67,5.165-6.22,7.835-.034.167-.214,2.127-.293,3.205-.433-.949-.862-1.9-1.332-2.846-1.356-2.732-2.814-5.455-4.257-8.178-.443-.833-.873-1.669-1.308-2.505.407-.093,5.237-1.214,7.055-2.609,1.615-1.238,3.329-3.267,3.314-5.422a3.613,3.613,0,0,0-3.9-3.7c-3.035.329-5.669,5.164-6.22,7.835-.041.2-.3,3.021-.325,3.742-.956-1.84-1.891-3.683-2.741-5.537a63.642,63.642,0,0,1-2.979-7.695c.19-.044,5.236-1.191,7.1-2.619,1.615-1.239,3.329-3.267,3.313-5.423a3.612,3.612,0,0,0-3.9-3.7c-3.036.329-5.669,5.165-6.22,7.834-.043.21-.316,3.246-.325,3.8-.048-.153-.113-.305-.158-.458a46.656,46.656,0,0,1-1.544-8.126c-.17-1.516-.247-2.975-.292-4.395.962-.118,5.351-.7,7.168-1.8,1.743-1.055,3.668-2.882,3.889-5.026a3.612,3.612,0,0,0-3.472-4.1c-3.053-.006-6.2,4.511-7.043,7.1-.046.142-.352,1.626-.559,2.711-.01-.642-.033-1.3-.03-1.918,0-2.309.15-4.423.3-6.294.091-1.063.194-2.023.3-2.92.884-.608,4.414-3.1,5.5-4.882,1.06-1.739,1.927-4.247,1.136-6.252a3.614,3.614,0,0,0-4.973-2.044c-2.713,1.4-3.426,6.862-2.978,9.551.04.232,1.064,3.8,1.11,3.766l.053-.037c-.12.861-.237,1.785-.345,2.8-.186,1.872-.379,3.989-.433,6.306a64.062,64.062,0,0,0,.178,7.486,47.085,47.085,0,0,0,1.387,8.261c.009.032.021.064.03.1-.48-.755-1.894-2.819-2.021-2.966-1.783-2.061-6.442-5-9.252-3.8a3.614,3.614,0,0,0-1.6,5.134C255.093,329.465,257.579,330.4,259.592,330.693Z",
    transform: "translate(-253.116 -290.603)",
    fill: "#cbcbcb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M325.064,319.474c.047.029.974-3.561,1.008-3.794.375-2.7-.486-8.139-3.235-9.467a3.612,3.612,0,0,0-4.916,2.178c-.737,2.025.2,4.51,1.3,6.219C320.524,316.617,325.06,319.472,325.064,319.474Z",
    transform: "translate(-266.233 -293.727)",
    fill: "#cbcbcb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M309.763,437.616H280.472l-3.661-32.53h36.614Z",
    transform: "translate(-257.873 -314.034)",
    fill: "#fff",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1250",
    "data-name": "Group 1250",
    transform: "translate(19.609 97.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M277.654,412.579l.355,3.152h34.563l.355-3.152Z",
    transform: "translate(-277.654 -412.579)",
    fill: "#eef0f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M311.992,424.449l.355-3.152H278.636l.355,3.152Z",
    transform: "translate(-277.855 -414.364)",
    fill: "#eef0f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1290",
    "data-name": "Group 1290",
    transform: "translate(532 337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M5.1,0H50.224a5.1,5.1,0,0,1,5.1,5.1V34.18a5.1,5.1,0,0,1-5.1,5.1H5.1A5.1,5.1,0,0,1,0,34.18V5.1A5.1,5.1,0,0,1,5.1,0Z",
    transform: "translate(0 2.737)",
    fill: "#fff",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 55.323,
    height: 39.28,
    rx: 5.1,
    transform: "translate(2.394 0)",
    fill: "#fff",
    stroke: "#eef0f2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1293",
    "data-name": "Group 1293",
    transform: "translate(527.445 392.245)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1259",
    "data-name": "Group 1259",
    transform: "translate(24.589 44.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M687.111,427.874c-3.371,0-6.744-2.159-8.547-3.841a1.785,1.785,0,1,1,2.435-2.61c.051.048,5.451,4.98,8.611,1.819,2.743-2.744,5.612-8.228,5.524-12.984a7.694,7.694,0,0,0-2.371-5.743c-1.428-1.328-2.8-1.921-4.094-1.754-2.246.287-3.814,2.706-3.829,2.73a1.785,1.785,0,0,1-3.023-1.9c.1-.157,2.446-3.848,6.366-4.369,2.4-.321,4.757.581,7.011,2.675a11.285,11.285,0,0,1,3.51,8.292c.108,5.8-3.222,12.229-6.569,15.575A6.888,6.888,0,0,1,687.111,427.874Z",
    transform: "translate(-677.996 -399.16)",
    fill: "#fff",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1260",
    "data-name": "Group 1260",
    transform: "translate(24.589 44.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M685.422,429.645A13.371,13.371,0,0,1,681,427.027a1.785,1.785,0,1,0-2.435,2.61,15.215,15.215,0,0,0,6.588,3.612Z",
    transform: "translate(-677.996 -405.019)",
    fill: "#cbcbcb",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M682.73,403.657a1.785,1.785,0,0,0,3.023,1.9,7.747,7.747,0,0,1,2.131-2.089l.3-3.988A10.4,10.4,0,0,0,682.73,403.657Z",
    transform: "translate(-678.91 -399.479)",
    fill: "#cbcbcb",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M677.516,435.846H653.871l-2.956-39.409h29.557Z",
    transform: "translate(-647.864 -354.288)",
    fill: "#fff",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 6.425,
    cy: 11.521,
    rx: 6.425,
    ry: 11.521,
    transform: "translate(8.029 47.892)",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M647.847,347.1a21.607,21.607,0,0,1,1.361-3.66",
    transform: "translate(-647.236 -343.441)",
    fill: "none",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M654.818,383.637s6.655-6.655-.443-14.641c-5.317-5.981-7.9-11.714-7.179-17.756",
    transform: "translate(-647.079 -345.037)",
    fill: "none",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M673.866,377.548a13.013,13.013,0,0,0-1.436-3.425",
    transform: "translate(-652.268 -349.721)",
    fill: "none",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M672.988,389.93a18.229,18.229,0,0,0,1.429-7.942",
    transform: "translate(-652.382 -351.331)",
    fill: "none",
    stroke: "#cbcbcb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1297",
    "data-name": "Group 1297",
    transform: "translate(382.328 351.647)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_51",
    "data-name": "Rectangle 51",
    width: 10.728,
    height: 42.212,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1298",
    "data-name": "Group 1298",
    transform: "translate(398.82 340.604)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_52",
    "data-name": "Rectangle 52",
    width: 10.728,
    height: 53.255,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1299",
    "data-name": "Group 1299",
    transform: "translate(415.313 338.721)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_53",
    "data-name": "Rectangle 53",
    width: 10.728,
    height: 55.138,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1300",
    "data-name": "Group 1300",
    transform: "translate(431.806 360.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_54",
    "data-name": "Rectangle 54",
    width: 10.728,
    height: 33.374,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1301",
    "data-name": "Group 1301",
    transform: "translate(448.298 332.187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_55",
    "data-name": "Rectangle 55",
    width: 10.728,
    height: 61.672,
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1302",
    "data-name": "Group 1302",
    transform: "translate(464.791 321.21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_56",
    "data-name": "Rectangle 56",
    width: 10.728,
    height: 72.649,
    transform: "translate(0)",
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1303",
    "data-name": "Group 1303",
    transform: "translate(371.946 301.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M-84.453,379.328H-95.384l1.283,2.223-32.346,19.327h-28.671l-41.118,21.1,2.642,5.148,39.874-20.462h28.87l33.642-20.1,1.289,2.233Z",
    transform: "translate(196.236 -379.328)",
    fill: "#f90"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1295",
    "data-name": "Group 1295",
    transform: "translate(224.188 473.803)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_55",
    "data-name": "Line 55",
    x2: 352.011,
    transform: "translate(18.278)",
    fill: "none",
    stroke: "#dbdbdb",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M0,0H9.477",
    fill: "#dbdbdb",
    stroke: "#dbdbdb",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1306",
    "data-name": "Group 1306",
    transform: "translate(542.964 343)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(11.563 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M429.921,279.79a10.747,10.747,0,0,0,1.436-3.994l.436.064.862.127h.011a12.032,12.032,0,0,0-.226-4.68l-1.282.318a10.751,10.751,0,0,0-1.813-3.837l1.062-.79a11.98,11.98,0,0,0-3.469-3.153l-.684,1.135a10.727,10.727,0,0,0-3.994-1.436l.191-1.309a12.109,12.109,0,0,0-4.68.226l.318,1.282a10.751,10.751,0,0,0-3.837,1.813l-.79-1.062a11.983,11.983,0,0,0-3.153,3.469l1.135.684a10.729,10.729,0,0,0-1.436,3.994l-.926-.136-.379-.052,0,0a12.111,12.111,0,0,0,.226,4.68l1.282-.317a10.77,10.77,0,0,0,1.817,3.84l-1.062.79a11.956,11.956,0,0,0,3.464,3.15l.684-1.135a10.754,10.754,0,0,0,4,1.438l-.15,1.017-.041.292a12.086,12.086,0,0,0,4.675-.229l-.317-1.282a10.863,10.863,0,0,0,3.844-1.815l.79,1.062a12.046,12.046,0,0,0,3.146-3.467Zm-12.264-.554a5.856,5.856,0,1,1,8.038-1.994A5.855,5.855,0,0,1,417.658,279.235Z",
    transform: "translate(-408.57 -262.106)",
    fill: "#eef0f2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    transform: "translate(0 13.785)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M286.892,423.392a5.66,5.66,0,0,0-1.575-1.585l.129-.193.255-.381,0-.005a6.334,6.334,0,0,0-2.277-.95l-.139.681a5.662,5.662,0,0,0-2.234,0l-.135-.684a6.306,6.306,0,0,0-2.283.937l.385.582a5.647,5.647,0,0,0-1.585,1.575l-.579-.387a6.375,6.375,0,0,0-.95,2.277l.681.139a5.662,5.662,0,0,0,0,2.234l-.684.135a6.31,6.31,0,0,0,.937,2.283l.582-.385a5.648,5.648,0,0,0,1.575,1.585l-.274.41-.111.168h0a6.377,6.377,0,0,0,2.277.95l.139-.681a5.671,5.671,0,0,0,2.237,0l.135.684a6.3,6.3,0,0,0,2.281-.936l-.385-.582a5.662,5.662,0,0,0,1.587-1.577l.45.3.129.086a6.365,6.365,0,0,0,.948-2.275l-.681-.139a5.72,5.72,0,0,0,.005-2.238l.684-.135a6.342,6.342,0,0,0-.938-2.28Zm-3.035,5.707a3.083,3.083,0,1,1,.868-4.273A3.083,3.083,0,0,1,283.857,429.1Z",
    transform: "translate(-275.899 -420.271)",
    fill: "#f90"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M768.852,683.822a18.649,18.649,0,0,0,.194-2.542,19.119,19.119,0,0,0-36.653-7.322,13.351,13.351,0,0,0-22.181,9.817h-2.487a12.824,12.824,0,0,0-12.87,12.7h0a12.824,12.824,0,0,0,12.87,12.7H767.9a12.824,12.824,0,0,0,12.87-12.7h0A12.8,12.8,0,0,0,768.852,683.822Z",
    transform: "translate(-297.814 -458.924)",
    fill: "#eef0f2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin2);
export default __webpack_public_path__ + "static/media/login-2.091f539ef0a13226c82b1b769046f623.svg";
export { ForwardRef as ReactComponent };